import { Button, CardBody, CardFooter, CardHeader, CardImg, CardText, CardTitle, Row, Col } from 'react-bootstrap';
import { Card } from 'react-bootstrap';
import logo from '../../../images/logoW.png';
import { useTranslation } from 'react-i18next';

const FooterPage = () => {
  const { t } = useTranslation();
  const columns = t('landing.footer.columns', { returnObjects: true });

  return (
    <div>
      <Card>
        <CardTitle
          style={{
            backgroundColor: '#90EE90',
            textAlign: 'center',
            color: '#fff',
            border: '1px solid #CECECE',
            paddingTop: '35px',
            paddingBottom: '25px'
          }}
        >
          {t('landing.footer.title')}
        </CardTitle>

        <div>
          <Row>
            <Col sm={3}>
              <Card style={{ height: '100%', width: '100%', backgroundColor: '#006400', border: '1px solid #CECECE', margin: '10px' }}>
                <CardBody>
                  <div className="d-block justify-content-center align-items-center w-100" style={{ margin: '40px' }}>
                    <CardImg style={{ width: '150px', padding: '15px', marginLeft: '75px' }} variant="top" src={logo} />
                    <br />
                    <Button>{t('landing.footer.download')}</Button>
                  </div>
                </CardBody>
              </Card>
            </Col>

            <Col sm={9}>
              <Card style={{ height: '100%', backgroundColor: '#B0F2B6', border: '1px solid #CECECE', margin: '10px' }}>
                <CardBody>
                  <Row style={{ margin: '35px 80px' }}>
                    {Object.keys(columns).map((key, index) => (
                      <Col key={index} style={{ color: '#fff' }} sm>
                        <h4 style={{ color: '#FFA400' }}>{columns[key].title}</h4>
                        {columns[key].items.map((item, i) => (
                          <p key={i} style={item.includes("confidentialité") ? { whiteSpace: 'nowrap' } : {}}>
                            {item}
                          </p>
                        ))}
                      </Col>
                    ))}
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </Card>
    </div>
  );
};

export default FooterPage;
